export default __webpack_public_path__ + "static/media/katalog-urmak.e0d690e6.jpg";